// eslint-disable-next-line
import BiMap from 'bimap'
import { NameSpacing } from '../../NonReact/utils/NameSpacing'
import { AdminBackendPermissionNames, BackendPermissionNames } from '../Common/Constants/Permissions'

const DETAILS = 'details'
export const PERMISSIONS = 'permissions'
export const EXTENSION_ENDPOINT = 'extensionendpoint'
const REPORTING = 'reporting'
const ROLE_NAMESPACING = 'role'
const SETTINGS = 'settings'
export const API_KEYS_FIELD_NAME: string = 'apiKeys'

export const ADMINISTRATOR_NAMESPACING = 'administrator'
export const ROLE_PERMISSIONS: string = 'rolepermissions'

export const ROLE_PERMS_NAMESPACE: string = NameSpacing(ADMINISTRATOR_NAMESPACING, ROLE_PERMISSIONS)

export enum DetailsTabFieldNames {
    FULLNAME = 'fullname',
    USERNAME = 'username',
    EMAIL = 'email',
    PASSWORD = 'password',
    DEFAULT_LANGUAGE = 'defaultlanguage',
    PASSWORD_CHANGE_REQUIRED = 'passwordchangerequired',
    SEND_WELCOME_EMAIL = 'sendwelcomeemail',
    ENABLE_MFA = 'enablemfa',
    CX_INTEGRATION_LICENCE = 'cxilicence',
    CXS_SUBSCRIPTION = 'cxsSubscription',
    CXR_SUBSCRIPTION = 'cxrSubscription',
    CXS_SCORE_ENABLED = 'cxsScoreEnabled',
    CXR_RECORD_ENABLED = 'cxrRecordEnabled',
    CXI_DATA_ENTITLEMENT = 'cxidataentitlement',
    TIMEZONE = 'timezone'
}

export enum PermissionsTabFieldNames {
    CM_ENVIRONMENT = 'cmenvironment',
    TEL_SERVER = 'telephonyserver',
    PARTITION = 'partition',
    DEVICE = 'device',
    AGENT = 'agent',
    SYNCHRONISE_SUPERVISOR_PERMISSIONS = 'synchronisesupervisorpermissions'
}

export enum ExtensionEndpointTabFieldNames {
    TEL_SERVER = 'telephonyserver',
    PARTITION = 'partition',
    DEVICE = 'device',
    AGENT = 'agent'
}

export enum ReportingTabFieldNames {
    REPORTING_LEVEL = 'reportinglevel',
    DEFAULT_REPORTS = 'defaultreports',
    REPORTING_API = 'reportingapi',
    ENHANCED_FEATURES = 'enhancedfeatures',
    CALL_RECORDING = 'callrecording',
    ADVANCED_SUPERVISOR = 'advancedsupervisor',
    READ_ONLY = 'readonly',
    REPORT_TEMPLATE_USER = 'reportTemplateUser'
}

export enum AdministratorTabFieldNames {
    ADMINISTRATOR = 'administrator',
    ADMIN_ROLE = 'adminrole',
    SERVICE_NOTIFICATION = 'servicenotification',
    CONCURRENT_SIGNINS = 'concurrentsignins'
}

export enum RolePermissionsFieldNames {
    CME_MANAGEMENT = 'cmeManagement',
    DEVICES = 'devices',
    AGENTS = 'agents',
    DIRECTORY = 'directory',
    APPLICATION_USER = 'applicationUser',
    ADMIN_ROLES = 'adminRoles',
    CODES = 'codes',
    TELEPHONY_SERVER = 'telServer',
    PARTITIONS = 'paritions',
    RECORDINGS = 'recordings',
    MESSAGES = 'messages',
    DATABASE = 'database',
    USER_ROLE = 'userRole',
    CRM_CONFIG = 'crmConfig',
    CLIENT_CONFIG = 'clientConfig',
    POLICY = 'policy',

    LICENCES = 'licences',
    LOGGING = 'logging',
    LOG_MANAGEMENT = 'logManagement',
    AUDIT_TRAIL = 'auditTrail',
    TEL_MODULE_STATUS = 'telModuleStatus',
    CALL_CONTROL = 'callControl',
    SERVER_STATUS = 'serverStatus',

    COPY_REPORTS_TO = 'copyReportsTo',
    SIGN_IN_AS = 'signInAs',
    BILLING_FILES_DOWNLOAD = 'billingFilesDownload',
    BILLING_SUMMARY = 'billSummary',
    CHANGE_TELEPHONY_BILLING_STATUS = 'changeTelephonyBillingStatus',
    CHANGE_CME_BILLING_STATUS = 'changeCmeBillingStatus',
    CHANGE_LICENCE_LEVEL = 'changeLicenceLevel',
    SYNC_PARTITION = 'syncpartition',
    EPT_ACCESS = 'eptAccess',
    LOG_FILES_DOWNLOAD = 'logFilesDownload',
    TELSYS_SYNC_RESTRICTIONS = 'telSysSyncRestrictions',
    CME_BRANDING_CONFIG = 'cmeBrandingConfig',
    EDIT_OWN_CME_DOMAIN_PROFILE = 'editOwnCMEDomainProfile',
    EDIT_OWN_CME_BRANDING = 'editOwnCMEBranding',
    EDIT_OWN_CME_PROVISIONING = 'editOwnCMEProvisioning',
    CRM_TEMPLATE_MANAGE = 'crmTemplateManage'
}

export enum SettingsTabFieldNames {
    LOCKED_OUT = 'lockedout',
    PROMPT_TOS = 'prompttos',
    NOTIFY_PASSWORD_CHANGE = 'notifypasswordchange',
    SERVICE_NOTIFICATION = 'servicenotification',
    AUTH_NOTIFICATIONS = 'authnotifications',
    NEW_DEVICE_NOTIFICATIONS = 'newdevicenotifications',
    CONCURRENT_SIGNINS = 'concurrentsignins',
    UPDATE_INTERVAL = 'updateintervals',
    MEDIA_PLAYER = 'disablemediaplayer',
    DRAG_AND_DROP = 'draganddropfunctionality',
    JAVASCRIPT_OUTPUT = 'javascriptoutput'
}

export enum RoleFieldNames {
    ROLE = 'role'
}

export const UserDetailsNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(DETAILS, fieldName)

export const PermissionsNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(PERMISSIONS, fieldName)

export const ExtensionEndpointNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(EXTENSION_ENDPOINT, fieldName)

export const ReportingNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(REPORTING, fieldName)

export const AdministratorNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(ADMINISTRATOR_NAMESPACING, fieldName)

export const RoleNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(ROLE_NAMESPACING, fieldName)

export const SettingsNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(SETTINGS, fieldName)

export const RolePermissionsNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    AdministratorNameSpacing(NameSpacing(ROLE_PERMISSIONS, fieldName))

// Map the fieldnames to the backend names.
export const formToPermissionsMap = new BiMap<string, string>()

formToPermissionsMap.push(RolePermissionsFieldNames.DEVICES, AdminBackendPermissionNames.DEVICE)
formToPermissionsMap.push(RolePermissionsFieldNames.AGENTS, AdminBackendPermissionNames.AGENTS)
formToPermissionsMap.push(RolePermissionsFieldNames.DIRECTORY, AdminBackendPermissionNames.DIRECTORY)
formToPermissionsMap.push(RolePermissionsFieldNames.APPLICATION_USER, AdminBackendPermissionNames.USER)
formToPermissionsMap.push(RolePermissionsFieldNames.CODES, AdminBackendPermissionNames.CODE)
formToPermissionsMap.push(RolePermissionsFieldNames.TELEPHONY_SERVER, AdminBackendPermissionNames.TEL_SYS)
formToPermissionsMap.push(RolePermissionsFieldNames.PARTITIONS, AdminBackendPermissionNames.PARTITION)
formToPermissionsMap.push(RolePermissionsFieldNames.RECORDINGS, AdminBackendPermissionNames.RECORDING)
formToPermissionsMap.push(RolePermissionsFieldNames.CME_MANAGEMENT, AdminBackendPermissionNames.CME)
formToPermissionsMap.push(RolePermissionsFieldNames.MESSAGES, AdminBackendPermissionNames.MESSAGE)
formToPermissionsMap.push(RolePermissionsFieldNames.DATABASE, AdminBackendPermissionNames.DATABASE)
formToPermissionsMap.push(RolePermissionsFieldNames.USER_ROLE, AdminBackendPermissionNames.USER_ROLE)
formToPermissionsMap.push(RolePermissionsFieldNames.CLIENT_CONFIG, AdminBackendPermissionNames.INTEGRATOR_CLIENT)
formToPermissionsMap.push(RolePermissionsFieldNames.CRM_CONFIG, AdminBackendPermissionNames.CRM_CONFIG)

formToPermissionsMap.push(RolePermissionsFieldNames.LOG_MANAGEMENT, AdminBackendPermissionNames.LOG_MGMT)
formToPermissionsMap.push(RolePermissionsFieldNames.CALL_CONTROL, AdminBackendPermissionNames.CALL_CONTROL)
formToPermissionsMap.push(RolePermissionsFieldNames.LICENCES, AdminBackendPermissionNames.LICENCE)
formToPermissionsMap.push(RolePermissionsFieldNames.LOGGING, AdminBackendPermissionNames.LOGGING)
formToPermissionsMap.push(RolePermissionsFieldNames.AUDIT_TRAIL, AdminBackendPermissionNames.AUDIT_TRAIL)
formToPermissionsMap.push(RolePermissionsFieldNames.TEL_MODULE_STATUS, AdminBackendPermissionNames.TEL_SYS_STATUS)
formToPermissionsMap.push(RolePermissionsFieldNames.SERVER_STATUS, AdminBackendPermissionNames.SERVER_STATUS)

formToPermissionsMap.push(RolePermissionsFieldNames.COPY_REPORTS_TO, AdminBackendPermissionNames.COPY_REPORTS_TO)
formToPermissionsMap.push(RolePermissionsFieldNames.SIGN_IN_AS, AdminBackendPermissionNames.SIGN_IN_AS)
formToPermissionsMap.push(
    RolePermissionsFieldNames.BILLING_FILES_DOWNLOAD,
    AdminBackendPermissionNames.BILLING_FILES_DOWNLOAD
)
formToPermissionsMap.push(RolePermissionsFieldNames.BILLING_SUMMARY, AdminBackendPermissionNames.BILLING_SUMMARY)
formToPermissionsMap.push(
    RolePermissionsFieldNames.CHANGE_TELEPHONY_BILLING_STATUS,
    AdminBackendPermissionNames.CHANGE_TELSYS_BILLABLE
)
formToPermissionsMap.push(
    RolePermissionsFieldNames.CHANGE_LICENCE_LEVEL,
    AdminBackendPermissionNames.CHANGE_LICENCE_LEVEL
)
formToPermissionsMap.push(RolePermissionsFieldNames.SYNC_PARTITION, AdminBackendPermissionNames.SYNC_PARTITION)
formToPermissionsMap.push(RolePermissionsFieldNames.EPT_ACCESS, AdminBackendPermissionNames.EPT_ACCESS)
formToPermissionsMap.push(RolePermissionsFieldNames.LOG_FILES_DOWNLOAD, AdminBackendPermissionNames.LOG_FILES_DOWNLOAD)
formToPermissionsMap.push(
    RolePermissionsFieldNames.TELSYS_SYNC_RESTRICTIONS,
    AdminBackendPermissionNames.TELSYS_SYNC_RESTRICTIONS
)
formToPermissionsMap.push(
    RolePermissionsFieldNames.CME_BRANDING_CONFIG,
    AdminBackendPermissionNames.CME_BRANDING_CONFIG
)
formToPermissionsMap.push(
    RolePermissionsFieldNames.EDIT_OWN_CME_BRANDING,
    AdminBackendPermissionNames.EDIT_OWN_CME_BRANDING
)
formToPermissionsMap.push(
    RolePermissionsFieldNames.EDIT_OWN_CME_PROVISIONING,
    AdminBackendPermissionNames.EDIT_OWN_CME_PROVISIONING
)
formToPermissionsMap.push(
    RolePermissionsFieldNames.EDIT_OWN_CME_DOMAIN_PROFILE,
    AdminBackendPermissionNames.EDIT_OWN_CME_DOMAIN_PROFILE
)
formToPermissionsMap.push(RolePermissionsFieldNames.POLICY, AdminBackendPermissionNames.POLICY)
formToPermissionsMap.push(
    RolePermissionsFieldNames.CRM_TEMPLATE_MANAGE,
    AdminBackendPermissionNames.CRM_TEMPLATE_MANAGE
)

export const nonAdminFormToPermissionsMap = new BiMap()

nonAdminFormToPermissionsMap.push(
    ReportingNameSpacing(ReportingTabFieldNames.REPORTING_API),
    BackendPermissionNames.REPORTING_API
)
nonAdminFormToPermissionsMap.push(
    ReportingNameSpacing(ReportingTabFieldNames.ENHANCED_FEATURES),
    BackendPermissionNames.ENHANCED_FEATURES
)
nonAdminFormToPermissionsMap.push(
    SettingsNameSpacing(SettingsTabFieldNames.CONCURRENT_SIGNINS),
    BackendPermissionNames.CONCURRENT_SIGNINS
)
nonAdminFormToPermissionsMap.push(
    SettingsNameSpacing(SettingsTabFieldNames.NOTIFY_PASSWORD_CHANGE),
    BackendPermissionNames.SERVICE_NOTIFICATION
)

export const FULLNAME_COMPONENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.FULLNAME)
export const USERNAME_COMPONENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.USERNAME)
export const EMAIL_COMPONENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.EMAIL)
export const PASSWORD_COMPONENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.PASSWORD)
export const PASSWORD_CHANGE_COMPONENT_NAME: string = UserDetailsNameSpacing(
    DetailsTabFieldNames.PASSWORD_CHANGE_REQUIRED
)
export const SEND_WELCOME_COMPONENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.SEND_WELCOME_EMAIL)
export const ENABLE_MFA_COMPONENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.ENABLE_MFA)
export const DEFAULT_LANG_COMPONENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.DEFAULT_LANGUAGE)
export const TIMEZONE_COMPONENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.TIMEZONE)
export const CXI_LICENCE_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.CX_INTEGRATION_LICENCE)
export const CXS_SUBSCRIPTION_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.CXS_SUBSCRIPTION)
export const CXR_SUBSCRIPTION_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.CXR_SUBSCRIPTION)
export const CXS_SCORE_ENABLED_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.CXS_SCORE_ENABLED)
export const CXR_RECORD_ENABLED_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.CXR_RECORD_ENABLED)
export const CXI_DATA_ENTITLEMENT_NAME: string = UserDetailsNameSpacing(DetailsTabFieldNames.CXI_DATA_ENTITLEMENT)

export const ROLE_COMPONENT_NAME: string = RoleNameSpacing(RoleFieldNames.ROLE)
export const TEL_SYS_PERM_NAME: string = PermissionsNameSpacing(PermissionsTabFieldNames.TEL_SERVER)
export const CME_PERM_NAME: string = PermissionsNameSpacing(PermissionsTabFieldNames.CM_ENVIRONMENT)
export const PARTITION_PERM_NAME: string = PermissionsNameSpacing(PermissionsTabFieldNames.PARTITION)
export const DEVICES_PERM_NAME: string = PermissionsNameSpacing(PermissionsTabFieldNames.DEVICE)
export const AGENTS_PERM_NAME: string = PermissionsNameSpacing(PermissionsTabFieldNames.AGENT)
export const SYNCHRONISE_SUPERVISOR_PERMISSIONS_NAME: string = PermissionsNameSpacing(
    PermissionsTabFieldNames.SYNCHRONISE_SUPERVISOR_PERMISSIONS
)

export const ENDPOINT_TEL_SYS_NAME: string = ExtensionEndpointNameSpacing(ExtensionEndpointTabFieldNames.TEL_SERVER)
export const ENDPOINT_PARTITION_NAME: string = ExtensionEndpointNameSpacing(ExtensionEndpointTabFieldNames.PARTITION)
export const ENDPOINT_DEVICE_NAME: string = ExtensionEndpointNameSpacing(ExtensionEndpointTabFieldNames.DEVICE)
export const ENDPOINT_AGENT_NAME: string = ExtensionEndpointNameSpacing(ExtensionEndpointTabFieldNames.AGENT)

export const REPORTING_LEVEL_NAME: string = ReportingNameSpacing(ReportingTabFieldNames.REPORTING_LEVEL)
export const REPORTING_DEFAULT_REPORTS_COMPONENT_NAME: string = ReportingNameSpacing(
    ReportingTabFieldNames.DEFAULT_REPORTS
)
export const REPORTING_API_COMPONENT_NAME: string = ReportingNameSpacing(ReportingTabFieldNames.REPORTING_API)
export const ENHANCED_FEATURES_COMPONENT_NAME: string = ReportingNameSpacing(ReportingTabFieldNames.ENHANCED_FEATURES)
export const CALL_RECORDING_NAME: string = ReportingNameSpacing(ReportingTabFieldNames.CALL_RECORDING)
export const READ_ONLY_COMPONENT_NAME: string = ReportingNameSpacing(ReportingTabFieldNames.READ_ONLY)
export const REPORT_TEMPLATE_USER_COMPONENT_NAME: string = ReportingNameSpacing(
    ReportingTabFieldNames.REPORT_TEMPLATE_USER
)

export const UPDATE_INTERVAL_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.UPDATE_INTERVAL)
export const LOCKED_OUT_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.LOCKED_OUT)
export const PROMPT_TOS_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.PROMPT_TOS)
export const NOTIFY_PASSWORD_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.NOTIFY_PASSWORD_CHANGE)
export const CONCURRENT_SIGNINS_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.CONCURRENT_SIGNINS)
export const SERVICE_NOTIF_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.SERVICE_NOTIFICATION)
export const AUTH_NOTIFICATIONS_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.AUTH_NOTIFICATIONS)
export const NEW_DEVICE_NOTIFICATIONS_COMPONENT_NAME: string = SettingsNameSpacing(
    SettingsTabFieldNames.NEW_DEVICE_NOTIFICATIONS
)
export const MEDIA_PLAYER_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.MEDIA_PLAYER)
export const DRAG_AND_DROP_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.DRAG_AND_DROP)
export const JAVASCRIPT_OUTPUT_COMPONENT_NAME: string = SettingsNameSpacing(SettingsTabFieldNames.JAVASCRIPT_OUTPUT)

export const API_KEY_NAME_FIELD_NAME: string = `${API_KEYS_FIELD_NAME}.name`
export const API_KEY_EXPIRY_FIELD_NAME: string = `${API_KEYS_FIELD_NAME}.expiry`
